import { applySort } from './sorting';

export const applySorting = (arr) => {
  let resArr = applySort(arr, 'ruleTypeName', 'ASC');
  resArr = applySort(arr, 'isPending', 'DESC');
  resArr = applySort(arr, 'isActive', 'DESC');
  return resArr;
};
